module.exports = __webpack_public_path__ + "img/logo_en.020e04d6.png";